// extracted by mini-css-extract-plugin
export default {"wrapper":"sliding_wrapper__5dG6a","slider":"sliding_slider__O2zA6","sliderContainer":"sliding_sliderContainer__GFAVV"};